<template lang="pug">
  transition(
    name="modal"
  )
    .modal-mask(
      @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_quota-capacity(
        @click="onClickWrapper($event)"
        )
          .modal__body
            .form
              .form__elem
                .form-elem(
                :class="{'form-elem_error':errors.emptyValue.value || errors.wrongValue.value}"
                )
                  .form-elem__title Количество людей
                  .form-elem__body
                    input.input.input_full(
                    ref="input"
                    v-model="value"
                    @input="resetError"
                    )
              .form__elem
                .form-elem
                  .form-elem__body
                    button.button.button_paint-main.button_full(
                    @click.prevent="updateCapacity"
                    )
                      .button__text Сохранить
                  .form-elem__error(
                  v-if="currentErrorMessage.length > 0"
                  ) {{currentErrorMessage}}
</template>

<script>
import Inputmask from "inputmask";
import {mapActions} from "vuex";

export default {
  name: "QuotaCapacityModal",
  components: {
    Inputmask
  },
  props: {
    currentValue: {
      type: [String, Number],
      default: ""
    },
    mask: {
      type: Object,
      default: () => {}
    },
    quotaId: {
      type: [String, Number],
      default: ""
    }
  },
  computed: {
  },
  data() {
    return {
      value: "",
      errors: {
        emptyValue: {
          value: false,
          message: "Введите количество людей"
        },
        wrongValue: {
          value: false
        }
      },
      currentErrorMessage: ""
    };
  },
  methods: {
    ...mapActions([
      "updateQuota"
    ]),
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
    },
    validation() {
      if (this.value.length === 0) {
        this.errors.emptyValue.value = true;
        this.currentErrorMessage = this.errors.emptyValue.message;
        return false;
      }
      return true;
    },
    updateCapacity() {
      if (!this.validation()) {
        return;
      };
      this.updateQuota({
        id: this.quotaId,
        data: {
          capacity: this.value
        }
      }).then(res => {
        if (res.status === 200) {
          this.$emit("on-change-capacity", this.value);
          this.$emit("close");
        } else if (res.status === 400) {
          this.errors.wrongValue.value = true;
          this.currentErrorMessage = res.data.non_field_errors[0].message;
        } else {
          alert(`Ошибка ${res.status}`);
        }
      });
    },
    resetError() {
      this.errors.emptyValue.value = false;
      this.errors.wrongValue.value = false;
      this.currentErrorMessage = "";
    }
  },
  created() {
    this.value = this.currentValue;
  },
  mounted() {
    this.mask.mask(this.$refs.input);
  }
};
</script>
